<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 10:07:38
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-02-07 09:04:20
-->
<template>
  <div class="form">
    <div class="form-title">基本信息设置</div>
    <el-form ref="baseForm" class="baseForm" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="考试计划名称：" prop="examPlanName">
        <el-input v-model="form.examPlanName" :readonly="isReadOnly"></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="planDescribe">
        <el-input
          v-model="form.planDescribe"
          type="textarea"
          :rows="4"
          maxlength="255"
          show-word-limit
          :readonly="isReadOnly"
        ></el-input>
      </el-form-item>
      <el-form-item label="职业/等级：" prop="job">
        <el-cascader
          v-model="form.job"
          placeholder="请选择职业/等级"
          :options="jobLevelList"
          :props="{
            value: 'id',
            label: 'jobName',
            children: 'levelList',
          }"
          :disabled="isReadOnly"
          @change="handleJobLevelChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="工种：" prop="workTypeId">
        <el-select v-model="form.workTypeId" placeholder="请选择工种" :disabled="isReadOnly">
          <el-option
            v-for="item in workTypeList"
            :key="item.id"
            :label="item.workTypeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交卷规则：" prop="commitPaperTime">
        <div class="form-text">
          考试开始
          <el-input-number
            v-model="form.commitPaperTime"
            :readonly="isReadOnly"
            :controls="false"
            :min="0"
            class="timeInput"
          ></el-input-number>
          分钟后允许交卷（只能填整数）
        </div>
      </el-form-item>
      <el-form-item label="考试时间：" prop="examStartTime">
        <el-date-picker
          v-model="form.examStartTime"
          :readonly="isReadOnly"
          type="date"
          placeholder="选择考试时间"
          style="width: 100%;"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="阅卷规则：" prop="markingPaperDay">
        <div class="form-text">
          完成阅卷后
          <el-input-number
            v-model="form.markingPaperDay"
            :readonly="isReadOnly"
            :controls="false"
            :min="0"
            :max="99"
            class="timeInput"
          ></el-input-number>
          天后试卷归档（阅卷人不允许修改分值）
        </div>
      </el-form-item>
      <el-form-item v-if="!isReadOnly">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="onNext">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { examPlanGetById, filterJobLevel, filterWorkType, examPlanUpdate } from '@/api/exam'
import to from 'await-to'
export default {
  name: 'BaseInfo',
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        workTypeId: '',
      },
      rules: {
        examPlanName: [{ required: true, message: '请输入考试计划名称', trigger: 'blur' }],
        job: [{ required: true, message: '请选择职业/等级', trigger: 'change' }],
        commitPaperTime: [
          { required: true, message: '请输入交卷规则', trigger: 'blur' },
          { type: 'number', message: '请输入整数' },
        ],
        examStartTime: [{ required: true, message: '请选择考试时间', trigger: 'change' }],
        markingPaperDay: [
          { required: true, message: '请输入阅卷规则', trigger: 'blur' },
          { type: 'number', message: '请输入整数' },
        ],
      },
      jobLevelList: [],
      workTypeList: [],
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getExamPlan()
    }
    this.getJobLevelList()
  },
  methods: {
    async getExamPlan() {
      const [res, err] = await to(examPlanGetById({ id: this.$route.params.id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      this.form.job = [res.data.jobId + '', res.data.jobLevel]
      if (this.form.jobId) {
        this.getWorkTypeList()
      }
      this.$refs.baseForm.resetFields()
    },
    async getJobLevelList() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    async getWorkTypeList() {
      const [res, err] = await to(filterWorkType({ jobId: this.form.jobId }))
      if (err) return this.$message.warning(err.msg)
      this.workTypeList = res.data
    },
    handleJobLevelChange() {
      this.form.jobId = this.form.job[0]
      this.form.jobLevel = this.form.job[1]
      this.form.workTypeId = ''
      this.getWorkTypeList()
    },
    async onSubmit() {
      if (this.$route.params.id) {
        this.form.id = this.$route.params.id
      }
      this.$refs.baseForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(examPlanUpdate(this.form))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('保存成功')
          this.$router.push('/exam/plan')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async onNext() {
      if (this.$route.params.id) {
        this.form.id = this.$route.params.id
      }
      this.$refs.baseForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(examPlanUpdate(this.form))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('保存成功')
          this.$emit('next', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.form {
  height: 100%;
  .form-title {
    height: 78px;
    line-height: 78px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #e8ebf2;
    padding-left: 20px;
    box-sizing: border-box;
  }
  /deep/.baseForm {
    box-sizing: border-box;
    height: calc(100% - 78px);
    padding-top: 30px;
    overflow: auto;
    padding-bottom: 10px;
    .el-form-item {
      margin-bottom: 30px;
      &:last-child {
        padding-top: 20px;
      }
      .form-text {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
    }
    .el-input,
    .el-textarea,
    .el-date-editor {
      width: 440px !important;
      .el-input__inner,
      .el-textarea__inner {
        border-radius: 2px;
      }
      input {
        height: 40px;
      }
    }
    .timeInput {
      width: 60px;
      margin: 0 10px;
      .el-input {
        width: 60px !important;
      }
      input {
        height: 32px;
      }
      .el-input__inner {
        padding: 0 5px;
      }
    }
    .el-button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      margin-left: 0;
      margin-right: 20px;
    }
  }
}
</style>
